import { PricingMainType } from '@lib/sanity/queries/modules/pricingMain/types';
import PortableText, { TextVariant } from '@ui/Text/PortableText';
import { usePricingFrequency } from '../PricingMain/PricingFrequencyContext';

export type ChipProps = {
  data: PricingMainType['heroPricing'];
};

export default function Chip({ data }: ChipProps) {
  const { isYearlyFrequency } = usePricingFrequency();

  if (!data?.length || !isYearlyFrequency) {
    return null;
  }

  return (
    <div className="relative pl-2">
      <div
        className="flex items-center justify-center gap-2 rounded-lg bg-[#1C1C1F] px-2  py-1 
            before:absolute before:left-[5px] before:z-[-1] before:mx-auto before:h-4  before:w-4 before:rotate-45"
        style={{
          backgroundColor: `rgba(${data[0]?.priceDiscountColor?.rgb?.r},${data[0]?.priceDiscountColor?.rgb?.g},${data[0]?.priceDiscountColor?.rgb?.b},${data[0]?.priceDiscountColor?.rgb?.a})`,
        }}
      >
        <PortableText
          content={data[0].priceDiscountLabel}
          className="font-medium uppercase text-white"
          variant={TextVariant.TextUnicase}
        />
      </div>
    </div>
  );
}
